<template>
  <div data-cy="alert-message" class="alert" :class="type">
    <div v-if="icon" class="icon">
      <icon-base :icon="icon" :icon-color="iconColor" />
    </div>
    <div class="alert-message">
      <slot />
    </div>
    <div v-if="$slots.actions" class="alert-actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { COLORS } from "@/helpers/constants";

import type { Component, ComponentOptions, PropType } from "vue";

const props = defineProps({
  type: {
    type: String,
    default: "success",
  },
  icon: {
    type: [String, Object] as PropType<
      string | (ComponentOptions | ComponentOptions["setup"]) | Component
    >,
  },
});

const iconColor = computed(() => {
  let color;
  switch (props.type) {
    case "success":
      color = COLORS[0];
      break;
    case "warning":
      color = COLORS[5];
      break;
    case "error":
      color = COLORS[2];
      break;
    default:
      color = COLORS[0];
      break;
  }
  return `rgb(${color})`;
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.alert {
  @apply flex flex-col items-start space-y-4 p-4 text-headline lg:flex-row lg:space-y-0 lg:space-x-4;
}
.alert-message {
  @apply flex-auto space-y-1;
}
.alert-actions {
  @apply flex items-center space-x-2;
}

.success {
  @apply bg-green-50;
}
.error {
  @apply bg-red-50;
}
.warning {
  @apply bg-yellow-50;
}
</style>
